var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReqHist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 16,
    fill: "#003675",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1647_9050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6C25.523 6 30 10.477 30 16C30 21.523 25.523 26 20 26C14.477 26 10 21.523 10 16H12C12 20.418 15.582 24 20 24C24.418 24 28 20.418 28 16C28 11.582 24.418 8 20 8C17.536 8 15.332 9.114 13.865 10.865L16 13H10V7L12.447 9.446C14.28 7.336 16.984 6 20 6ZM21 11V15.585L24.243 18.828L22.828 20.243L19 16.413V11H21Z",
    fill: "#FFCE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1647_9050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqHist);
export default __webpack_public_path__ + "static/media/req-hist.97d90e87bee4b3b1cfb9bd4ec4abfdb1.svg";
export { ForwardRef as ReactComponent };